import * as React from 'react';
import { darkAcqa, gray } from '../../../consts/variables';
import { __ } from '../../../helpers/TranslationService';
import { IMobileWaypoint } from '../../../interfaces';
import { WaypointRow } from './WaypointRow';

export const tableStyles: Record<string, React.CSSProperties> = {
    row: {
        display: 'flex',
        borderBottom: `1px solid ${gray}`,
        width: '100%',
        fontSize: 15,
        padding: '10px 0px',
        position: 'relative',
    },
    col1: {
        width: 50,
        flex: '0 0 auto',
    },
    col2: {
        flex: '1 1 auto',
    },
    col3: {
        textAlign: 'center',
        minWidth: 40,
        flex: '0 0 auto',
        display: 'flex',
        alignItems: 'center',
        alignContent: 'center',
        justifyContent: 'center',
    },
};

const styles: Record<string, React.CSSProperties> = {
    table: {
        padding: '15px 10px',
        borderTop: `1px solid ${gray}`,
    },
    tableHeader: {
        ...tableStyles.row,
        fontWeight: 'bold',
    },
};

interface IProps {
    waypoints: IMobileWaypoint[];
    collapsedArr: boolean[];
    onHeaderClick(index: number): void;
}

export function WaypointsTable(props: IProps) {
    const getWayPointTableHeader = () => (
        <div style={styles.tableHeader}>
            <div style={{ ...tableStyles.col1 }}>{__('day', 'dreamlines')}</div>
            <div style={{ ...tableStyles.col2 }}>{__('travel station', 'dreamlines')}</div>
            <div style={{ ...tableStyles.col3 }}>{__('Infos', 'dreamlines')}</div>
            {/* Todo : Add the translation id for Infos */}
        </div>
    );
    const lastItemIndex = props.waypoints.length - 1;
    let isEmbarked: boolean = false;

    const getWaypoints = () =>
        props.waypoints.map((waypoint, index) => {
            const setEmbarked = () => {
                if (waypoint.isPortOfDisembarkation || waypoint.isPortOfEmbarkation) {
                    if (waypoint.isPortOfDisembarkation) {
                        isEmbarked = false;
                    } else {
                        isEmbarked = true;
                    }
                }
            };
            const isActualWayPoint =
                !!waypoint && (!!waypoint.arrival || !!waypoint.image || !!waypoint.description);
            return (
                <React.Fragment key={index}>
                    <WaypointRow
                        index={index}
                        {...waypoint}
                        collapsed={props.collapsedArr[index]}
                        onHeaderClick={
                            isActualWayPoint
                                ? (e) => {
                                      props.onHeaderClick(e);
                                  }
                                : null
                        }
                        isLastRow={index === lastItemIndex}
                        isEmbarked={isEmbarked}
                    />
                    {setEmbarked()}
                </React.Fragment>
            );
        });

    return (
        <div style={styles.table}>
            {props.waypoints.length > 0 && getWayPointTableHeader()}
            {getWaypoints()}
        </div>
    );
}
